interface AppEnv {
    API_BASE_URL: string
    UPLOADS_BASE_URL: string
    RAZORPAY_KEY_ID: string
    SITE_NAME: string
}

const apiBase = (import.meta.env.VITE_API_BASE_URL as string) || 'http://localhost:5000/api'

const env: AppEnv = {
    API_BASE_URL: apiBase,
    UPLOADS_BASE_URL: (import.meta.env.VITE_UPLOADS_BASE_URL as string) || apiBase.replace(/\/api$/, '') + '/uploads',
    RAZORPAY_KEY_ID: (import.meta.env.VITE_RAZORPAY_KEY_ID as string) || '',
    SITE_NAME: 'Indian Studies Review'
}

export default env
